var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ HoverState: _vm.hover },on:{"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave,"mousemove":_vm.onMouseMove}},[_vm._t("default",null,{"hover":_vm.hover})],2)}
var staticRenderFns = []

export { render, staticRenderFns }